import Animals from "../../components/ClassOne/EnvironmentScience/Animals";
import OurBody from "../../components/ClassOne/EnvironmentScience/OurBody";
import Plants from "../../components/ClassOne/EnvironmentScience/Plants";
import Transport from "../../components/ClassOne/EnvironmentScience/Transport";
import OurHelpers from "../../components/ClassOne/EnvironmentScience/OurHelpers";
import LivingNonLiving from "../../components/ClassOne/EnvironmentScience/LivingNonLiving";
import NeighbourhoodPlaces from "../../components/ClassOne/EnvironmentScience/NeighbourhoodPlaces";
import MyFood from "../../components/ClassOne/EnvironmentScience/MyFood";
import MyWater from "../../components/ClassOne/EnvironmentScience/MyWater";
import MyShelter from "../../components/ClassOne/EnvironmentScience/MyShelter";
import MyClothing from "../../components/ClassOne/EnvironmentScience/MyClothing";
import MyAir from "../../components/ClassOne/EnvironmentScience/MyAir";
import CleanSafety from "../../components/ClassOne/EnvironmentScience/CleanSafety";
import Materials from "../../components/ClassOne/EnvironmentScience/Materials";
import WeatherSky from "../../components/ClassOne/EnvironmentScience/WeatherSky";
import Festivals from "../../components/ClassOne/EnvironmentScience/Festivals";

import OurBodyMenu from "./OurBody";
import PlantsMenu from "./Plants";
import AnimalsMenu from "./Animals";
import TransportMenu from "./Transport";
import OurHelpersMenu from "./OurHelpers";
import LivingNonLivingMenu from "./LivingNonLiving";
import NeighbourhoodPlacesMenu from "./NeighbourhoodPlaces";
import MyFoodMenu from "./MyFood";
import MyWaterMenu from "./MyWater";
import MyShelterMenu from "./MyShelter";
import MyClothingMenu from "./MyClothing";
import MyAirMenu from "./MyAir";
import CleanSafetyMenu from "./CleanSafety";
import MaterialsMenu from "./Materials";
import WeatherSkyMenu from "./WeatherSky";
import FestivalsMenu from "./Festivals";

// Define the type for menu items
interface MenuItem {
    url: string;
    title: string;
    component?: React.FC; // Optional React functional component
    subMenu?: MenuItem[]; // Allow subMenu to be an array of MenuItem
}


const topics: MenuItem[] = [
    //{ url: "/class-one/environmental-science/our-body", title: "Our Body", component: OurBody, subMenu: OurBodyMenu},
    // { url: "/class-one/environmental-science/clock", title: "Others in My World" },
    { url: "/class-one/environmental-science/my-need-food", title: "My Needs – Food", component: MyFood, subMenu: MyFoodMenu },
    { url: "/class-one/environmental-science/my-need-water", title: "My Needs – Water", component: MyWater, subMenu: MyWaterMenu },
    { url: "/class-one/environmental-science/my-need-shelter", title: "My Need – Shelter", component: MyShelter, subMenu: MyShelterMenu },
    { url: "/class-one/environmental-science/my-need-clothing", title: "My Need – Clothing", component: MyClothing, subMenu: MyClothingMenu },
    { url: "/class-one/environmental-science/my-need-air", title: "My Need – Air", component: MyAir, subMenu: MyAirMenu },
    { url: "/class-one/environmental-science/clean-safety-healthy", title: "Clean, Safe and Healthy", component: CleanSafety, subMenu: CleanSafetyMenu},
    { url: "/class-one/environmental-science/neighbourhood-place", title: "Neighbourhood Places", component: NeighbourhoodPlaces,  subMenu: NeighbourhoodPlacesMenu },
    { url: "/class-one/environmental-science/living-non-living-things", title: "Living & Non Living Things", component: LivingNonLiving, subMenu: LivingNonLivingMenu },
    { url: "/class-one/environmental-science/plants", title: "Plants", component: Plants, subMenu: PlantsMenu },
    { url: "/class-one/environmental-science/animals", title: "Animals", component: Animals, subMenu: AnimalsMenu },
    { url: "/class-one/environmental-science/transport-communication", title: "Transport & Communication", component: Transport, subMenu: TransportMenu },
    { url: "/class-one/environmental-science/festivals", title: "Festivals", component: Festivals, subMenu: FestivalsMenu },
    { url: "/class-one/environmental-science/our-helpers", title: "Our Helpers", component: OurHelpers, subMenu: OurHelpersMenu },
    { url: "/class-one/environmental-science/weather-sky", title: "Weather & Sky", component: WeatherSky, subMenu: WeatherSkyMenu },
    { url: "/class-one/environmental-science/material-types", title: "Types of Materials", component: Materials, subMenu: MaterialsMenu },
];


export default topics;